var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (typeof this.questions != 'undefined')?_c('div',{staticClass:"progress-bar"},_vm._l((_vm.questions),function(value,index){return _c('span',{key:index,staticClass:"step",class:value})}),0):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }